import styled, { css } from 'vue-styled-components';

import {
    FLEX_CENTER_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const ComboControlsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
    justify-content: flex-end;
    padding: 12px 16px;
    cursor: default;
    background-color: var(--color-gray-white);
`;

export const SegmentGroupWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    justify-content: space-between;
    width: 342px;
`;

export const SegmentGroup = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 8px;
`;

export const SegmentLabel = styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: var(--color-gray-90);
    white-space: nowrap;
`;

export const SegmentControl = styled(FLEX_VERTICAL_CENTER_DIV)`
    background: var(--color-gray-10);
    border: 1px solid var(--color-gray-30);
    border-radius: 10px;
    padding: 4px;
    gap: 2px;
`;

const activeProps = { active: Boolean };

export const SegmentButton = styled(FLEX_CENTER_DIV, activeProps)`
    height: 28px;
    min-width: 36px;
    padding: 0 8px;
    gap: 4px;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 6px;
    border: 1px solid transparent;

    ${({ active }) =>
        active
            ? css`
                  background: var(--color-gray-white);
                  border-color: var(--color-gray-60);
                  box-shadow: 0px 1px 2px rgba(60, 70, 79, 0.08);
              `
            : css`
                  background: transparent;
              `}

    svg {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }
`;

export const SegmentButtonLabel = styled.span`
    font-size: 13px;
    font-weight: 400;
    line-height: 19.5px;
    color: var(--color-gray-100);
    white-space: nowrap;
`;

export const SegmentDivider = styled.div`
    width: 1px;
    height: 20px;
    background: var(--color-gray-30);
    flex-shrink: 0;
`;
